var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-step"},[_c('h3',{staticClass:"title text--secondary"},[_vm._v(_vm._s(_vm.$ft(_vm.doc.title)))]),_c('p',{staticClass:"text--disabled mt-n2"},[_vm._v(_vm._s(_vm.$t("common.placeholder.todo")))])])}
var staticRenderFns = []

export { render, staticRenderFns }